/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addEmailRestrictions,
  getEmailRestrictions,
} from "../../../../api/User";
import { UserAtom } from "../../../../atoms/UserAtom";
import { UserEmailRestrictionsAtom } from "../../../../atoms/UserEmailRestrictionsAtom";
import StyledBlockInput, { BlockInputType } from "../../../StyledBlockInput";

export default function BlockPhone() {
  const [isLoading, setIsLoading] = useState(false);
  const setEmailRestrictions = useSetRecoilState(UserEmailRestrictionsAtom);
  const [user, setUser] = useRecoilState(UserAtom);

  async function handleBlockPhone(phones: string[]) {
    setIsLoading(true);

    try {
      await addEmailRestrictions({ phoneNumbersBlocked: phones });
      toast("Success", { type: "success" });
      const emailRestrictions = await getEmailRestrictions();
      setEmailRestrictions(emailRestrictions);
      setUser({ ...user, emailRestrictions });
    } catch {
      toast("Error", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <StyledBlockInput
      handleClick={handleBlockPhone}
      isLoading={isLoading}
      inputType={BlockInputType.Phone}
      replaceAll={(value: string) => {
        return (
          "+" +
          value.replace(/[a-zA-Z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "")
        );
      }}
      placeholder="Enter phone"
      isValid={(value: string) => {
        const isValid = value.replace("+", "").length > 9;
        if (!isValid) return `${value} is not a valid phone.`;
        return "";
      }}
    />
  );
}
